<template>
    <div class="wizard__wrap">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">
                    {{ agencyName }}
                </div>
            </div>

            <div class="wizard__block-title">
                New upsell with {{ currentBrand }}
                <span class="subtitle"
                    >Please provide detailed information about a service in this
                    SOW</span
                >
            </div>

            <div class="wizard__block-upsell">
                <div class="row jus-c--space-between">
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div
                            class="form-field form-field--modal form-field--tree"
                            style="margin-bottom: 8px"
                        >
                            <label for="service_id"
                                >Services <span class="red">*</span></label
                            >
                            <treeselect
                                v-model="upsell.services"
                                id="service_id"
                                name="service_id"
                                :multiple="true"
                                :valueConsistsOf="'LEAF_PRIORITY'"
                                :options="services_list"
                            />
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div
                            class="form-field form-field--datepicker"
                            style="margin-bottom: 8px"
                            ref="datepicker"
                        >
                            <label for="kickoff_date">Kick-off date</label>
                            <input
                                type="text"
                                id="kickoff_date"
                                v-model="upsell.kick_off_date"
                                name="kickoff_date"
                                @input="onChangeDatePicker"
                                @changeDate="onChangeDatePicker"
                            />
                            <button type="button" class="btn btn--icon">
                                <i class="icon icon-calendar"></i>
                            </button>
                            <span
                                class="error"
                                style="left: 0"
                                v-if="errors.kick_off_date"
                                >{{ errors.kick_off_date }}</span
                            >
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div
                            class="form-field checkbox-wrap"
                            style="margin-bottom: 1em"
                        >
                            <input
                                @change="
                                    is_create_custom_service =
                                        !is_create_custom_service
                                "
                                :checked="is_create_custom_service"
                                type="checkbox"
                                id="is_create_custom_service"
                                name="is_create_custom_service"
                            />
                            <label for="is_create_custom_service">
                                <i class="icon icon-checkmark"></i>
                            </label>
                            Create my custom service
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="form-field form-field--text">
                            <label for="custom_service"
                                >Custom service name</label
                            >
                            <input
                                type="text"
                                id="custom_service"
                                v-model="upsell.custom_service"
                                name="custom_service"
                                :disabled="!is_create_custom_service"
                            />
                            <span
                                class="error"
                                style="left: 0"
                                v-if="errors.custom_service"
                                >{{ errors.custom_service }}</span
                            >
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div
                            class="form-field form-field--text"
                            style="margin-bottom: 24px; padding-right: 0"
                        >
                            <label for="sow_file">SOW</label>
                            <input
                                v-model="upsell.sow_title"
                                id="sow_title"
                                name="sow_title"
                                :readonly="true"
                            />
                            <!-- <span
                                class="error"
                                style="left: 0"
                                v-if="errors.sow_file"
                                >{{ errors.sow_file }}</span
                            > -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="row" v-for="t in brand_types">
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div class="row details-inline-wrap form-box">
                                    <span class="form-box-label"
                                        >{{ t.id === 1 ? "Type" : " "
                                        }}<span class="red" v-if="t.id === 1"
                                            >*</span
                                        ></span
                                    >
                                    <div
                                        class="form-field form-field--radiobutton"
                                    >
                                        <input
                                            type="radio"
                                            :id="`type_${t.id}`"
                                            v-model="upsell.type"
                                            :checked="upsell.type === t.id"
                                            name="type_id"
                                            class="type-create-deals js-edit-deal-type"
                                            :value="t.id"
                                            @change="onChangeType"
                                        />
                                        <label
                                            style="
                                                margin-bottom: 5px;
                                                margin-right: 12px;
                                            "
                                            :for="`type_${t.id}`"
                                            >{{ t.name }}</label
                                        >
                                        <span
                                            class="error"
                                            style="left: 0"
                                            v-if="errors.type"
                                            >{{ errors.type }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <div
                                    class="form-field form-field--text"
                                    style="padding-right: 10px"
                                >
                                    <label for="amount">{{
                                        getAmountLabel(t.id)
                                    }}</label>
                                    <CurrencyInput
                                        :id="`amount_field_${t.id}`"
                                        :ref="`amount_field_${t.id}`"
                                        :disabled="
                                            t.id !== upsell.type ||
                                            (t.id === 1 &&
                                                upsell.is_fluctuating_fee)
                                        "
                                        :name="`amount_field_${t.id}`"
                                        v-model="
                                            upsell[get_deal_service_type(t.id)]
                                        "
                                        @change="handleChangeAmount"
                                        :options="{
                                            currency: 'USD',
                                            hideCurrencySymbolOnFocus: false,
                                            hideGroupingSeparatorOnFocus: false,
                                            hideNegligibleDecimalDigitsOnFocus: false,
                                        }"
                                    />
                                    <span
                                        class="error"
                                        style="left: 0"
                                        v-if="
                                            upsell.type === t.id &&
                                            errors.amount
                                        "
                                        >{{ errors.amount }}</span
                                    >
                                </div>
                                <div
                                    class="form-field form-field--tree"
                                    v-if="t.id === 1"
                                >
                                    <label for="frequency">Frequency </label>
                                    <treeselect
                                        v-model="upsell.frequency"
                                        id="frequency"
                                        name="frequency"
                                        :disabled="upsell.type !== 1"
                                        :clearable="false"
                                        :multiple="false"
                                        :options="frequency_list"
                                    />
                                </div>
                            </div>
                            <div
                                class="col-xl-4 col-lg-4 col-md-4"
                                v-if="t.id === 1"
                            >
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="
                                        margin-bottom: 12px;
                                        margin-top: 16px;
                                    "
                                >
                                    <input
                                        type="radio"
                                        :checked="
                                            upsell.is_fluctuating_fee === false
                                        "
                                        id="is_fluctuating_fee_fixed"
                                        name="is_fluctuating_fee"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeFluctuatingFee(false)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        for="is_fluctuating_fee_fixed"
                                        >Fixed</label
                                    >
                                </div>
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="margin-bottom: 0"
                                >
                                    <input
                                        type="radio"
                                        :checked="
                                            upsell.is_fluctuating_fee === true
                                        "
                                        id="is_fluctuating_fee_true"
                                        name="is_fluctuating_fee"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeFluctuatingFee(true)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        for="is_fluctuating_fee_true"
                                        >Fluctuating fee</label
                                    >
                                </div>
                                <span
                                    class="error red"
                                    style="left: 0; font-size: 14px"
                                    v-if="
                                        upsell.type === 1 &&
                                        errors.is_fluctuating_fee
                                    "
                                    >{{ errors.is_fluctuating_fee }}</span
                                >
                                <!-- <div
                                    class="form-field checkbox-wrap"
                                    style="margin-bottom: 0; margin-top: 27px"
                                >
                                    <input
                                        :disabled="upsell.type !== 1"
                                        v-model="upsell.is_fluctuating_fee"
                                        type="checkbox"
                                        id="fluctuating_fee"
                                        name="fluctuating_fee"
                                    />
                                    <label for="fluctuating_fee">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                    Fluctuating fee
                                </div> -->
                            </div>
                            <div
                                class="col-xl-4 col-lg-4 col-md-4"
                                v-if="t.id === 2"
                            >
                                <div
                                    class="form-field form-field--text"
                                    style="position: relative"
                                >
                                    <label for="amount">Number of pmts</label>
                                    <input
                                        type="number"
                                        :disabled="upsell.type !== 2"
                                        id="number_of_pmts"
                                        v-model="upsell.number_of_pmts"
                                        name="number_of_pmts"
                                    />
                                    <span
                                        class="error"
                                        style="left: 0"
                                        v-if="
                                            upsell.type === 2 &&
                                            errors.number_of_pmts
                                        "
                                        >{{ errors.number_of_pmts }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-field checkbox-wrap">
                        <input
                            v-model="isHasInvoice"
                            type="checkbox"
                            id="same_as_hq"
                            class="one-time-setup"
                            :name="'is_has_invoice'"
                            @change="
                                (e) => handleChangeInoviced(e.target.checked)
                            "
                        />
                        <label for="same_as_hq">
                            <i class="icon icon-checkmark"></i>
                        </label>
                        Invoiced ({{ invoicedPeriod }})
                    </div>
                </div>
                <div class="row" v-if="isHasInvoice">
                    <div
                        class="col-xl-3 col-lg-3 col-md-3"
                        style="padding-right: 12px"
                    >
                        <div class="form-field form-field--text">
                            <label for="sow_file"
                                >Invoice number
                                <span
                                    class="tooltip-btn"
                                    data-message="This is where you can record the internal invoice number associated with the invoice you sent your client for this transaction. Recording your internal invoice ID can help us keep track of which invoice is associated with which transaction"
                                    >?</span
                                ></label
                            >
                            <input
                                v-model="newInvoice.invoice_number"
                                id="invoice_number"
                                name="invoice_number"
                            />
                        </div>
                    </div>
                    <div
                        class="col-xl-3 col-lg-3 col-md-3"
                        style="padding-right: 12px"
                    >
                        <div class="form-field form-field--text">
                            <label for="sow_file">Amount</label>
                            <CurrencyInput
                                :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }"
                                v-model="newInvoice.amount"
                            />
                        </div>
                    </div>
                    <div
                        class="col-xl-3 col-lg-3 col-md-3"
                        style="padding-right: 12px"
                    >
                        <div class="form-field form-field--text">
                            <label for="sow_file">Collected</label>
                            <CurrencyInput
                                :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }"
                                v-model="newInvoice.collected"
                            />
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="form-field form-field--text">
                            <label for="sow_file">Hard cost</label>
                            <CurrencyInput
                                :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }"
                                v-model="newInvoice.hard_cost"
                            />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="form-field form-field--textarea">
                            <label for="terms">Terms</label>
                            <textarea
                                id="terms"
                                v-model="upsell.terms"
                                name="terms"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button
                    type="button"
                    @click="onPrevSection"
                    class="btn btn--prev btn--white"
                >
                    Previous
                </button>
                <button
                    type="button"
                    @click="onSaveNewUpsell"
                    class="btn btn--next btn--gray"
                >
                    Next
                </button>
            </div>

            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader";

import CurrencyInput from "../../../components/CurrencyInput";
import { Datepicker } from "vanillajs-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { SECTIONS } from "../consts";
import axios from "axios";
import { reInitAllTooltips } from "../../../helpers/_tooltip";
import moment from "moment";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Upsell",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isLoading: false,
            services_list: [],
            frequency_list: [
                {
                    id: 1,
                    label: "1m",
                },
                {
                    id: 12,
                    label: "1y",
                },
            ],
            brand_types: [
                {
                    id: 1,
                    name: "Retainer",
                },
                {
                    id: 2,
                    name: "Project",
                },
                {
                    id: 3,
                    name: "One-Time Fee",
                },
            ],
            upsell: {
                services: [],
                kick_off_date: null,
                custom_service: "",
                terms: "",
                sow_title: "",
                type: 1,
                one_time_fee: "",
                mounthly_fee: "",
                full_amount: "",
                number_of_pmts: "",
                frequency: 1,
                is_fluctuating_fee: null,
            },
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
                autohide: true,
            },
            wizard_draft_sow_id: null,
            errors: {
                service_id: null,
                type: null,
                amount: null,
                number_of_pmts: null,
                kick_off_date: null,
                sow_file: null,
                custom_service: null,
                is_fluctuating_fee: null,
            },
            urlRegex:
                /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,

            isHasInvoice: false,
            newInvoice: {
                amount: 0,
                collected: 0,
                hard_cost: 0,
                invoice_number: "",
            },
            is_create_custom_service: false,
        };
    },
    components: {
        Treeselect,
        ClipLoader,
        CurrencyInput,
    },
    mounted() {
        this.initDatePicker();

        this.getData();

        const is_has_invoice = this.$store.getters.getIsWithoutSOW;

        if (is_has_invoice) {
            this.isHasInvoice = is_has_invoice;
        }

        setTimeout(() => {
            reInitAllTooltips();
        }, 750);

        scrollToTop();
    },
    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        getDealId() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getDealSalesIndex
                ).deal_id || null
            );
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        sowIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },
        upsellIndex() {
            return this.$store.getters.getCurrentIndexUpsell;
        },
        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
        invoicedPeriod() {
            return (
                moment().subtract(1, "months").endOf("month").format("MMMM") ||
                ""
            );
        },
    },
    methods: {
        async getData() {
            await axios
                .post("/api/wizard/getList", {
                    page: "new_upsell",
                    deal_id: this.getDealId,
                    sow_index: this.sowIndex,
                    upsell_index: this.upsellIndex,
                })
                .then((res) => {
                    this.services_list = res.data.page.services;
                    this.wizard_draft_sow_id =
                        res.data.page.wizard_draft_sow_id;
                    this.upsell.sow_title = res.data.page.sow_title;

                    if (res.data.page.upsell_draft) {
                        this.setDataFromDraft(res.data.page.upsell_draft);
                    }
                })
                .catch((err) => console.log("err getData upsell", err));
        },
        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, this.datepicker_options);
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        setDataFromDraft(data = null) {
            if (data) {
                this.upsell.services = data.service_id;
                this.upsell.kick_off_date = data.kickoff_date;
                this.upsell.custom_service = data.custom_service;
                if (data.custom_service) {
                    this.is_create_custom_service = true;
                }
                this.upsell.type = data.type_id;
                this.upsell.number_of_pmts = data.num_of_payments;
                this.upsell.terms = data.terms;
                this.upsell.mounthly_fee =
                    data.type_id === 1 ? data.amount : "";
                this.upsell.full_amount = data.type_id === 2 ? data.amount : "";
                this.upsell.one_time_fee =
                    data.type_id === 3 ? data.amount : "";
                this.upsell.is_fluctuating_fee = data.fluctuating_fee;
                this.upsell.frequency = data.frequency ? data.frequency : 1;
                this.isHasInvoice = data.new_invoice.is_exist || false;

                if (data.new_invoice.is_exist) {
                    this.newInvoice.amount = data.new_invoice.amount;
                    this.newInvoice.collected = data.new_invoice.collected;
                    this.newInvoice.hard_cost = data.new_invoice.hard_cost;
                    this.newInvoice.invoice_number =
                        data.new_invoice.invoice_number;
                }
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.upsell.kick_off_date = date;
            }
        },

        handleChangeAmount(e) {
            const value = e.target.value;
            if (value) {
                switch (this.upsell.type) {
                    case 1:
                        this.upsell.mounthly_fee = value;
                        break;
                    case 2:
                        this.upsell.full_amount = value;
                        break;
                    case 3:
                        this.upsell.one_time_fee = value;
                        break;
                }
            }
        },
        getAmountLabel(id) {
            switch (id) {
                case 1:
                    return "Monthly fee";
                case 2:
                    return "Full Amount";
                case 3:
                    return "One-time fee";
                default:
                    return "Monthly fee";
            }
        },
        get_deal_service_type(id = null) {
            if (!id) {
                return;
            }

            switch (id) {
                case 1:
                    return "mounthly_fee";
                case 2:
                    return "full_amount";
                case 3:
                    return "one_time_fee";
                default:
                    return;
            }
        },
        onChangeType() {
            switch (this.upsell.type) {
                case 1:
                    this.upsell.full_amount = 0;
                    this.upsell.one_time_fee = 0;
                    break;
                case 2:
                    this.upsell.one_time_fee = 0;
                    this.upsell.mounthly_fee = 0;
                    break;
                case 3:
                    this.upsell.mounthly_fee = 0;
                    this.upsell.full_amount = 0;
                    break;
            }
        },

        onNextPage() {
            if (this.isEditUpsell) {
                this.onChangeSection(SECTIONS.FINAL_DASHBOARD, SECTIONS.UPSELL);
                return;
            }
            this.onChangeSection(SECTIONS.DO_YOU_HAVE_SERVICE, SECTIONS.UPSELL);
        },

        onPrevSection() {
            if (this.isEditUpsell) {
                this.onChangeSection(
                    SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW,
                    SECTIONS.DO_YOU_HAVE_UPSELL
                );
                return;
            }
            this.$store.commit("setIndexSOW", Number(this.sowIndex) - 1);
            this.onChangeSection(
                SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW,
                SECTIONS.DO_YOU_HAVE_UPSELL
            );
        },

        onSaveNewUpsell() {
            this.validateFields();

            if (
                this.errors.amount ||
                this.errors.service_id ||
                this.errors.type ||
                this.errors.sow_file ||
                this.errors.kick_off_date ||
                (this.errors.number_of_pmts && this.upsell.type === 2) ||
                this.errors.custom_service ||
                this.errors.is_fluctuating_fee
            ) {
                return;
            }

            this.isLoading = true;

            const data = {
                deal_id: this.getDealId,
                service_id: this.upsell.services,
                kickoff_date: this.upsell.kick_off_date,
                custom_service: this.upsell.custom_service,
                //amount: this.upsell.full_amount,
                //mounthly_fee: this.upsell.mounthly_fee,
                type_id: this.upsell.type,
                num_of_payments: this.upsell.number_of_pmts,
                //one_time_setup_fee: this.upsell.one_time_fee,
                terms: this.upsell.terms,
                sow_id: this.upsell.sow_file,
                amount:
                    this.upsell.type === 1
                        ? this.upsell.mounthly_fee
                        : this.upsell.type === 2
                        ? this.upsell.full_amount
                        : this.upsell.one_time_fee,
                fluctuating_fee: this.upsell.is_fluctuating_fee,
                wizard_draft_sow_id: this.wizard_draft_sow_id,
                upsell_index: this.upsellIndex,
                sow_index: this.sowIndex,
                frequency_retainer: this.upsell.frequency,
                new_invoice: {
                    is_exist: this.isHasInvoice,
                    invoice_number: this.newInvoice.invoice_number,
                    amount: this.newInvoice.amount,
                    hard_cost: this.newInvoice.hard_cost,
                    collected: this.newInvoice.collected,
                },
            };

            axios
                .post("/api/wizard/updateDraft", {
                    action: "createDealLineItem",
                    data: data,
                })
                .then(() => {
                    //this.$toast.success("New upsell has been saved!");
                    this.onNextPage();
                    this.$store.commit("setIsWithoutSOW", false);
                })
                .catch((err) => {
                    this.$toast.error("Something went wrong!");
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },
        validateFields() {
            this.errors.service_id = null;
            this.errors.type = null;
            this.errors.amount = null;
            this.errors.number_of_pmts = null;
            this.errors.sow_file = null;
            this.errors.custom_service = null;
            this.errors.kick_off_date = null;
            this.errors.is_fluctuating_fee = null;

            if (!this.upsell.services.length && !this.upsell.custom_service) {
                this.errors.custom_service = "Choose a service or enter custom";
            }
            if (!this.upsell.kick_off_date) {
                this.errors.kick_off_date = "Choose kick off date";
            }

            if (!this.upsell.type) {
                this.errors.type = "Required";
            }

            if (
                this.upsell.type === 1 &&
                this.upsell.is_fluctuating_fee === null
            ) {
                this.errors.is_fluctuating_fee = "Required";
            }
            if (
                (this.upsell.type === 2 && !this.upsell.full_amount) ||
                (this.upsell.full_amount &&
                    (this.upsell.full_amount <= 0 ||
                        !/^\d+$/.test(this.upsell.full_amount)))
            ) {
                this.errors.amount = "Invalid value";
            }

            if (this.upsell.type === 2 && !this.upsell.number_of_pmts) {
                this.errors.number_of_pmts = "Required";
            }

            if (
                this.upsell.type === 1 &&
                this.upsell.is_fluctuating_fee === false &&
                (this.upsell.mounthly_fee <= 0 ||
                    !/^\d+$/.test(this.upsell.mounthly_fee))
            ) {
                this.errors.amount = "Invalid value";
            }
            if (
                this.upsell.type === 3 &&
                (this.upsell.one_time_fee <= 0 ||
                    !/^\d+$/.test(this.upsell.one_time_fee))
            ) {
                this.errors.amount = "Invalid value";
            }

            if (
                this.upsell.number_of_pmts &&
                (this.upsell.number_of_pmts < 0 ||
                    !/^\d+$/.test(this.upsell.number_of_pmts))
            ) {
                this.errors.number_of_pmts = "Invalid value";
            }
        },

        handleChangeInoviced(is_checked) {
            if (is_checked) {
                setTimeout(() => reInitAllTooltips(), 750);
            }

            this.isHasInvoice = is_checked;
        },

        onChangeFluctuatingFee(flag = null) {
            this.upsell.is_fluctuating_fee = flag;
        },
    },
};
</script>
